import { RG_TYPE as e, getRgObjectsOfType as m } from "@project-rouge/rg-core";
import { getCountOfType as p } from "../../counting/index.js";
import { getLevelArrayMetric as n } from "../index4.js";
const a = (t) => n(t, (r, o) => p(m(r, e.Apartment), e.Module, o));
export {
  a as getLevelArrayApartmentModuleCount
};
//# sourceMappingURL=index2.js.map
